import { toast } from "sonner";
import { copyText } from "@/lib/clipboard";

interface CopyableIpProps {
  ip: string;
}

export function CopyableIp({ ip }: CopyableIpProps) {
  const handleCopy = async () => {
    if (await copyText(ip)) {
      toast.success(`Copied ${ip}`, { duration: 1_500 });
    } else {
      toast.error("Copy failed", { duration: 1_500 });
    }
  };

  return (
    <button
      type="button"
      onClick={handleCopy}
      title="Click to copy"
      className="font-mono text-muted-foreground hover:text-foreground hover:underline transition-colors"
    >
      {ip}
    </button>
  );
}
